import { sel, html } from 'fxjs/es';
import { staticTypo, typo } from '../../../../../../../services/MarppleShop/shared/typography/typo.js';
import { creatorPriceOfProduct } from '../../../../../../ProductColorPrice/S/fs.js';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import { MShopStudioPreDiscountProductS } from '../../../../../Studio/PreDiscountProduct/S/Function/module/MShopStudioPreDiscountProductS.js';
import { MShopUtilConstantS } from '../../../../../Util/S/Constant/module/MShopUtilConstantS.js';
import { NessLabsS } from '../../../../../../NessLabs/S/Function/module/NessLabsS.js';
import {
  isStoreProductCustomLevelAsset,
  isStoreProductCustomLevelUser,
} from '../../../../../../Creator/Product/S/fs.js';

export const makeProductPriceHtml = (product) => {
  if (!product.id) {
    return '';
  }

  const is_custom_asset_product = isStoreProductCustomLevelAsset(product?._?.stores_product.custom_level);
  const is_custom_user_product = isStoreProductCustomLevelUser(product?._?.stores_product.custom_level);
  const pre_discount_price = sel('_.pre_discount_product.pre_discount_price', product);
  const origin_price = creatorPriceOfProduct(product);
  const pre_discount_rate = pre_discount_price
    ? MShopStudioPreDiscountProductS.calcDiscountedRateByPercent(pre_discount_price, origin_price)
    : null;
  const need_tilde_currency =
    is_custom_user_product &&
    NessLabsS.needTildePrice({
      maker_type: product?._?.base_product?.maker_type,
      bp_option_ids: product?._?.selected_option_group?.bp_option_ids,
    });

  // 할인률 없을 때
  if (!pre_discount_rate) {
    if (MShopStudioPreDiscountProductS.isPreProductDiscountSupported()) {
      return html`<div class="app-product-item__price">
        <span
          class="app-product-item__price-number mp_currency"
          has_tilde=${is_custom_asset_product || need_tilde_currency}
          >${UtilS.commify(origin_price)}</span
        >
      </div>`;
    }

    return html`<div class="app-product-item__price mp_currency ${typo('20_bold')}">
      <span
        class="app-product-item__price-number ${MShopUtilConstantS.UNICA_KLASS} ${staticTypo(
          'unica_20_bold',
        )}"
        >${UtilS.commify(origin_price)}</span
      >
    </div>`;
  }

  // 할인률 있을 때
  return html`<div class="app-product-item__price">
    <span class="app-product-item__discount-rate">${pre_discount_rate}%</span>
    <span class="app-product-item__price-number mp_currency">${UtilS.commify(origin_price)}</span>
    <span class="app-product-item__price-number--deprecated mp_currency"
      ><span>${UtilS.commify(pre_discount_price)}</span></span
    >
  </div>`;
};
